import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Text, CheckBox } from 'src/Components'
import { IconLock } from 'src/Components/shared/Icon'

import { svgMessages } from './NotificationPlatformPrompt'
import styles from './TeaserWindow.module.scss'

const CheckBoxSvg = ({
  keyName,
  defaultValue,
  onChange,
  icon: Icon,
  locked,
  children
}) => {
  const [active, setActive] = useState(defaultValue)

  const handleChange = e => {
    if (onChange) {
      onChange(keyName, e.target.checked)
      setActive(!active)
    }
  }

  return (
    <CheckBox.Pink
      className={classnames(
        styles.fancyCheck,
        active && styles.active,
        locked && styles.locked
      )}
      checkClassName={styles.fancyCheckSquare}
      checkIcon={locked && IconLock}
      name={`checkbox_${keyName}`}
      checked={defaultValue}
      onChange={handleChange}
      tabIndex={locked && '-1'}
    >
      <div className={styles.svgWrapper}>
        <Icon />
      </div>
      <Text size='l'>
        <FormattedMessage {...svgMessages[keyName]} />
      </Text>
      {children}
      <Text element='div' size='xxxl' className={styles.lockWrapper}>
        <IconLock />
      </Text>
    </CheckBox.Pink>
  )
}

CheckBoxSvg.propTypes = {
  keyName: PropTypes.string.isRequired,
  defaultValue: PropTypes.bool,
  locked: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  onChange: PropTypes.func,
  children: PropTypes.any
}

export default CheckBoxSvg
